import PosBranchService from '@/api/PosBranchService'

const transformProducts = (input = []) => {
  return input.map((item) => {
    return {
      'productId': item.product_id,
      'productName': item.product_name,
    }
  })
}

const transformBranch = (input = {}) => {
  return {
    'branchId': input.branch_id,
    'name': input.name,
    'nameShort': input.name_short,
    'address': input.address,
    'whId': input.wh_id,
    'whName': input.wh_name,
    'shopId': input.shop_id,
    'createdBy': input.created_by,
    'createdAt': input.created_at,
    'assignProducts': transformProducts(input.assign_products || []),
    'favoriteProducts': transformProducts(input.favorite_products || []),
    'journal': input.journal,
  }
}

const transformBranches = (input = []) => {
  return input.map((item) => transformBranch(item))
}

// initial state
const state = {
  branches: transformBranches([]),
  branch: transformBranch({}),
}

// getters
const getters = {}

// mutations
const mutations = {
  setBranches (state, data) {
    state.branches = transformBranches(data)
  },
  setBranch (state, data) {
    state.branch = transformBranch(data)
  },
}

// actions
const actions = {
  async getPosBranches ({ commit }, _params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getBranches') >= 0) return

    try {
      const params = _params === undefined
        ? null
        : {
          page: _params.page || 1,
          limit: _params.limit || 100000,
        }

      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getBranches')

      const response = await PosBranchService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getBranches')

      result = response.data

      if (result.success) {
        commit('setBranches', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getPosBranch ({ commit }, { id, params }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getBranch') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getBranch')

      const response = await PosBranchService.getSingle(id, params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getBranch')

      result = response.data

      if (result.success) {
        commit('setBranch', result.data[0])
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async insertPosBranch ({ commit }, params) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('insertBranch') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'insertBranch')

      const response = await PosBranchService.insert(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'insertBranch')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async updatePosBranch ({ commit }, { id, params }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('updateBranch') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateBranch')

      const response = await PosBranchService.update(id, params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateBranch')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async updatePosBranchAssignProductIds ({ commit }, { id, params }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('updateBranchAssignProductIds') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateBranchAssignProductIds')

      const response = await PosBranchService.updateAssignProductIds(id, params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateBranchAssignProductIds')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async updatePosBranchFavoriteProductIds ({ commit }, { id, params }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('updateBranchFavoriteProductIds') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'updateBranchFavoriteProductIds')

      const response = await PosBranchService.updateFavoriteProductIds(id, params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'updateBranchFavoriteProductIds')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async deletePosBranch ({ commit }, id) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('deleteBranch') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'deleteBranch')

      const response = await PosBranchService.delete(id)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'deleteBranch')

      result = response.data

      if (result.success) {

      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/PosBranch.js